<template>
  <a-card :bordered="false">
    <!-- 抽屉 -->
    <a-drawer :title="$t('label.dictionaryList')" :width="screenWidth" @close="onClose" :visible="visible">
      <!-- 抽屉内容的border -->
      <div :style="{padding: '10px',border: '1px solid #e9e9e9',background: '#fff',}">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" :form="form" @keyup.enter.native="searchQuery">
            <a-row :gutter="10">
              <a-col :md="8" :sm="12">
                <a-form-item :label="$t('label.name')">
                  <a-input style="width: 120px" :placeholder="$t('label.pleaseEnterTheName')" v-model="queryParam.itemText" />
                </a-form-item>
              </a-col>
              <a-col :md="9" :sm="24">
                <a-form-item :label="$t('label.status')" style="width: 170px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select :placeholder="$t('tip.pleaseSelect')" v-model="queryParam.status">
                    <a-select-option value="1">{{ $t('label.normal') }}</a-select-option>
                    <a-select-option value="0">{{ $t('label.disable') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <span style="float: left" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">{{ $t('button.search') }}</a-button>
                  <a-button type="primary" @click="searchReset" style="margin-left: 8px">{{ $t('button.reset') }}</a-button>
                </span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :md="2" :sm="24">
                <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd">{{ $t('button.add') }}</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div>
          <a-table ref="table"
                   rowKey="id"
                   size="middle"
                   :columns="columns"
                   :dataSource="dataSource"
                   :pagination="ipagination"
                   :loading="loading"
                   @change="handleTableChange"
                   :rowClassName="getRowClassname">
            <template v-for="(item, index) in columns" :slot="item.slotName">
              <span :key="index">{{ $t(item.slotName) }}</span>
            </template>
            <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
              <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                <a>{{ $t('button.delete') }}</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
      </div>
    </a-drawer>
    <dict-item-modal ref="modalForm" @ok="modalFormOk" />
    <!-- 字典数据 -->
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { filterObj } from '@/utils/util'
import DictItemModal from './modules/DictItemModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'DictItemList',
  mixins: [JeecgListMixin],
  components: { DictItemModal },
  data() {
    return {
      columns: [
        {
          slotName: 'tableHeader.name',
          // title: '名称',
          align: 'center',
          dataIndex: 'itemText',
          scopedSlots: { customRender: 'itemText', title: 'tableHeader.name' }
        },
        {
          slotName: 'tableHeader.dataValue',
          // title: '数据值',
          align: 'center',
          dataIndex: 'itemValue',
          scopedSlots: { title: 'tableHeader.dataValue' }
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
        }
      ],
      queryParam: {
        dictId: '',
        dictName: '',
        itemText: '',
        delFlag: '1',
        status: []
      },
      slotName: 'tableHeader.operation',
      visible: false,
      screenWidth: 800,
      model: {},
      dictId: '',
      status: 1,
      labelCol: {
        xs: { span: 5 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 12 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        itemText: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheName') }] },
        itemValue: { rules: [{ required: true, message: this.$t('label.pleaseEnterDataValue') }] }
      },
      url: {
        list: `${MTC_AUTH}sys/dictItem/list`,
        delete: `${MTC_AUTH}sys/dictItem/delete`,
        deleteBatch: `${MTC_AUTH}sys/dictItem/deleteBatch`
      }
    }
  },
  created() {
    // 当页面初始化时,根据屏幕大小来给抽屉设置宽度
    this.resetScreenSize()
  },
  methods: {
    add(dictId) {
      this.dictId = dictId
      this.edit({})
    },
    edit(record) {
      if (record.id) {
        this.dictId = record.id
      }
      this.queryParam = {}
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.dictId = this.dictId
      this.model.status = this.status
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'itemText', 'itemValue'))
      })
      // 当其它模块调用该模块时,调用此方法加载字典数据
      this.loadData()
    },
    getQueryParams() {
      //update--begin--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
      this.ipagination.total = 0
      //update--end--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
      var param = Object.assign({}, this.queryParam)
      param.dictId = this.dictId
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      if (this.superQueryParams) {
        param[ 'superQueryParams' ] = encodeURI(this.superQueryParams)
        param[ 'superQueryMatchType' ] = this.superQueryMatchType
      }
      return filterObj(param)
    },
    // 添加字典数据
    handleAdd() {
      this.$refs.modalForm.add(this.dictId)
      this.$refs.modalForm.title = this.$t('button.add')
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
      this.form.resetFields()
      this.dataSource = []
    },
    // 抽屉的宽度随着屏幕大小来改变
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 600) {
        this.screenWidth = screenWidth
      } else {
        this.screenWidth = 600
      }
    },
    //update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
    //增加样式方法返回值
    getRowClassname(record) {
      if (record.status == 0) {
        return 'data-rule-invalid'
      }
    }
    //update--end--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
  }
}
</script>

<style lang="less" scoped>
//update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
/deep/ .data-rule-invalid {
  background: #f4f4f4;
  color: #bababa;
}

//update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
</style>